import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Divider from '@material-ui/core/Divider'
import {
  GroupIcon,
  AccessibilityIcon,
  UserPlusIcon,
  BarChartIcon,
  ChannelIcon,
  QuestionIcon,
} from 'app/components/icons'
import DiscoveryNewAI from './DiscoveryNewAI'
import { usePlace } from 'commons/usePlace'

const HelpTips = ({ appName, className, onClickStartTour }) => {
  const { formatMessage } = useIntl()
  const place = usePlace()
  const env = process.env
  const linkADA = env.REACT_APP_EXPIRING_MESSAGES_URL
  const articles = [
    {
      icon: <AccessibilityIcon color="#8D8D8D" classes="w-16" />,
      name: formatMessage({
        id: 'createNotification.dialog.help.articles.ada',
      }),
      link: env.REACT_APP_ADA_BLOG_URL,
    },
    {
      icon: <GroupIcon color="#8D8D8D" classes="w-16" />,
      name: formatMessage({
        id: 'createNotification.dialog.help.articles.groups',
      }),
      link: env.REACT_APP_ABOUT_GROUPS_URL,
    },
    {
      icon: <UserPlusIcon color="#8D8D8D" classes="w-16" />,
      name: formatMessage({
        id: 'createNotification.dialog.help.articles.subscribers',
      }),
      link: env.REACT_APP_ABOUT_SUBSCRIBERS_URL,
    },
    {
      icon: <BarChartIcon color="#8D8D8D" classes="w-16" />,
      name: formatMessage({
        id: 'createNotification.dialog.help.articles.metrics',
      }),
      link: env.REACT_APP_ABOUT_METRICS_URL,
    },
    {
      icon: <ChannelIcon color="#8D8D8D" classes="w-16" />,
      name: formatMessage({
        id: 'createNotification.dialog.help.articles.channels',
      }),
      link: env.REACT_APP_WHAT_ARE_CHANNELS_URL,
    },
    {
      icon: <QuestionIcon color="#8D8D8D" classes="w-16" />,
      name: formatMessage({
        id: 'createNotification.dialog.help.articles.help.center',
      }),
      link: env.REACT_APP_HELP_CENTER_URL,
    },
  ]

  return (
    <div className={className}>
      <div>
        {Boolean(place.enabledAi) && (
          <DiscoveryNewAI onClickStartTour={onClickStartTour}></DiscoveryNewAI>
        )}
      </div>
      <div className="border-gray-200 text-gray-700">
        <div className="w-fit pr-5 text-grey-400 space-y-5">
          <div className="font-bold text-16 text-blue-950">
            <FormattedMessage id="createNotification.dialog.hintsAndTips" />
          </div>
          <div className="text-14 leading-tight mt-3">
            <FormattedMessage id="createNotification.dialog.description1" />
          </div>

          <div className="text-14 leading-tight mt-3">
            <FormattedMessage id="createNotification.dialog.description2" />
          </div>

          <div className="text-14 leading-tight mt-3">
            <FormattedMessage id="createNotification.dialog.description3" />
          </div>
        </div>
      </div>
      <Divider className="w-full my-5" />
      <div className="my-5 border-gray-200 text-gray-700">
        <div className="w-fit text-grey-400 pr-5">
          <div className="font-bold text-blue-950 text-16">
            <FormattedMessage id="createNotification.dialog.help.additional.info" />
          </div>
          <div className="text-14 leading-tight mt-5">
            <div className="font-bold mb-3">
              <FormattedMessage id="createNotification.dialog.expiration" />
            </div>
            <FormattedMessage id="createNotification.dialog.expiration.description" />
            <a
              href={linkADA}
              className="mx-2 text-gray-700"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormattedMessage id="createNotification.dialog.readmore.link" />
            </a>
          </div>
          <Divider className="w-full my-5" />
          <div className="text-14 text-grey-400 leading-tight">
            <div className="font-bold mb-3">
              <FormattedMessage id="createNotification.dialog.shareMessage" />
            </div>
            <FormattedMessage
              id="createNotification.dialog.shareMessage.description"
              values={{ appName }}
            />
          </div>
          <Divider className="w-full my-5" />
          <div className="text-grey-400 text-14 leading-tight">
            <div className="font-bold mb-3">
              <FormattedMessage id="navigation.notifications.topics.label" />
            </div>
            <div className="mb-5">
              <FormattedMessage id="createNotification.dialog.topic.tips.line1" />
            </div>
            <div className="mb-5">
              <FormattedMessage id="createNotification.dialog.topic.tips.line2" />
            </div>
            <div className="mb-5">
              <FormattedMessage id="createNotification.dialog.topic.tips.line3" />
            </div>
          </div>
          <Divider className="w-full my-5" />
        </div>
      </div>

      <div className="pb-10 text-gray-700">
        <div className="w-fit pr-5">
          <div className="text-grey-300 text-16">
            <FormattedMessage id="createNotification.dialog.help.articles" />
          </div>
          {articles.map((item) => (
            <div
              key={item.name}
              className="text-xs font-bold leading-tight my-2 flex items-center"
            >
              <div>{item.icon}</div>

              <a
                href={item.link}
                className="no-underline mx-3 text-sky-600"
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.name}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default HelpTips
